export enum Permission {
  SeoSettings = 'seo_settings.modify',
}
